import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

import branding from '../assets/missions-branding.webp'
import design from '../assets/missions-design.webp'
import production from '../assets/missions-production.webp'
import postProduction from '../assets/missions-post-production.webp'
import uiux from '../assets/missions-ui-ux.webp'
import seo from '../assets/missioins-seo.webp'
import "../Mission.css";
import PageTransition from "../PageTransition";



const SERVICES = [
  { title: "Branding", image: branding, link: "/branding" },
  { title: "Design", image: design, link: "/" },
  { title: "SEO & GEO", image: seo, link: "/" },
  { title: "Production & Post-Production", image: production, link: "/production-post-production" },
  { title: "UI/UX Design", image: uiux, link: "/ui-ux" },
];

export default function ContentMissions() {
  const navigate = useNavigate();
const scrollRef = useRef(null);
const [activeIndex, setActiveIndex] = useState(0);

 useEffect(() => {
  const slides = document.querySelectorAll(".missions-slide");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const idx = Number(entry.target.dataset.index);
          setActiveIndex(idx);
          entry.target.classList.add("is-active");
        } else {
          entry.target.classList.remove("is-active");
        }
      });
    },
    { threshold: 0.6 }
  );

  slides.forEach((slide) => observer.observe(slide));
  return () => observer.disconnect();
}, []);

  return (
    <>
      <Header visible mode="normal" />
                 <PageTransition>

      <section className="missions-root">
        <div className="missions-scroll" ref={scrollRef}>

         {SERVICES.map((service, i) => (
          <div
            className="missions-slide"
            key={i}
            data-index={i}
            onClick={() => navigate(service.link)}
             >

              <div
                className="missions-bg"
                style={{ backgroundImage: `url(${service.image})` }}
              />

              <div className="missions-overlay" />

              <h1>{service.title}</h1>
            </div>
          ))}
        </div>
        <div className="missions-dots">
  {SERVICES.map((_, i) => (
    <button
      key={i}
      className={`dot ${activeIndex === i ? "active" : ""}`}
      onClick={() => {
        const target = scrollRef.current.children[i];
        target.scrollIntoView({ behavior: "smooth" });
      }}
    />
  ))}
</div>

      </section>
      </PageTransition>
    </>
  );
}
